import common_colors from './common_colors';

export default {
  cardHeader: '#3F3F46',
  cardContainer: '#27272A',
  cardInternalContent: '#3F3F46',
  cardBorder: '#56595C',
  cardLightBorder: '#47474A',

  navItemActive: '#3F3F46',

  textPrimary: '#F1F5F9',
  textSecondary: '#CBD5E1',
  textLink: '#35B2F8',
  textLinkVisited: '#C589F9',

  buttonBlue: '#0EA5E9',
  buttonFooterBackground: '#57575A',

  pageBackground: '#121212',
  defaultWindowBg: '#121212',
  defaultBackground: '#27272A',
  disabledBackground: '#18181B',
  activeItemBackground: '#3F3F46',

  statusBarBackground: '#303033',
  statusBarBackgroundAndroid: '#303033',
  bottomBarBackground: '#303033',
  menuPopupBackground: '#303033',

  calendarWeekdayHeader: '#57575A',
  calendarDayHeader: '#3F3F46',

  loginButtonBorder: '#0EA5E9',
  facebookButtonColor: '#F1F5F9',

  redResults: '#FF8282',
  greenResults: '#52C975',

  nativeTouchFeedbackAndroid: '#DFF2FD',

  helpersGray600: '#4B5563',

  ...common_colors,
};
